import { Card, LabelValueRow, Tabs } from 'components/core-v2'

export const Loading = () => (
  <Tabs.Panel value="portfolio">
    <Card.Wrapper>
      <LabelValueRow isLoading label="Type" />
      <LabelValueRow isLoading label="Name" />
      <LabelValueRow isLoading label="Rebalancing" />
      <LabelValueRow isLoading label="Tax classification" />
      <LabelValueRow isLoading label="Portfolio multiplier" />
    </Card.Wrapper>
  </Tabs.Panel>
)
